import { render } from "./DetailRow.vue?vue&type=template&id=4e04f886"
import script from "./DetailRow.vue?vue&type=script&lang=js"
export * from "./DetailRow.vue?vue&type=script&lang=js"

import exportComponent from "/Users/herianto/Projects/yeu-logistik/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Pages/Projects/DetailRow.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4e04f886"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4e04f886', __exports__)) {
    console.log('reload')
    api.reload('4e04f886', __exports__)
  }
  
  module.hot.accept("./DetailRow.vue?vue&type=template&id=4e04f886", () => {
    console.log('re-render')
    api.rerender('4e04f886', render)
  })

}


export default __exports__